module.exports = __webpack_public_path__ + "static/media/trckova.68af86bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/trckova.jpg
// module id = 501
// module chunks = 0